import Layout from '@/layout'

export const routerList = [
  {
    // path: '/contract',
    // component: Layout,
    // meta: {
    //   title: '合同',
    //   icon: 'icon-chanpinPIguanli-01'
    // },
    // alwaysShow: true,
    // children: [
    //   {
    //     path: '/contract/list',
    //     component: () => import('@/views/Contract/Index'),
    //     name: 'ContractList',
    //     meta: { title: '合同列表', affix: false }
    //   },
    //   {
    //     path: '/contract/detail',
    //     component: () => import('@/views/Contract/Detail'),
    //     name: 'ContractDetail',
    //     hidden: true,
    //     meta: { title: '合同详情', affix: false }
    //   }
    // ]
  }
]
